import type { Block } from "@/lib/api";
import { blocksToTiptapDoc, tiptapDocToBlocks } from "@/lib/tiptap/document-serializer";
import { blockSignature } from "./rebaseMerge";

/**
 * The local base after a rebase that adopted server blocks.
 *
 * A rebase takes the server's version of every block this editor didn't
 * touch. Those blocks are this editor's too now — unchanged — so the local
 * base has to say so. It used to keep only what this editor last pushed, and
 * when the next push also hit a 409 (another tab saving in between), an
 * adopted block no longer matched that stale base: it read as a local edit,
 * "collided" with the newer server copy, and this editor's older copy won —
 * overwriting the other tab's work while both tabs said Saved.
 *
 * The base is in this editor's format, so an adopted block is signed the way
 * the editor will write it: through the serializer's own round trip.
 */
export function advanceLocalBase(
  localBase: ReadonlyMap<string, string>,
  adopted: readonly Block[],
): Map<string, string> {
  const next = new Map(localBase);
  if (adopted.length === 0) return next;
  for (const block of tiptapDocToBlocks(blocksToTiptapDoc([...adopted]))) {
    next.set(block.id, blockSignature(block));
  }
  return next;
}
